import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { LONG_TAIL_MIN_WORDS, MODE, ORDER_METRICS, PRESET, VIEW } from '../scope';

/**
 * This report's own scope controls, laid out in the shared control grid beside the property and
 * the dates: what the rows are keyed by, how they are ordered, which metric that order reads, and
 * which local text preset is applied.
 *
 * View and Mode change the request and the ordering; Preset and Metric do not — they are applied
 * to rows already retrieved, which is why switching either never costs another request and why
 * the notes under them say so rather than leaving the user to guess.
 */
function ExtraControls({ t, draft, onChange }) {
    const option = (group, value) => ({
        value,
        label: t(`tools.pages_queries_changes.${group}.${value}`),
    });

    const viewOptions = Object.values(VIEW).map((value) => option('views', value));
    const modeOptions = Object.values(MODE).map((value) => option('modes', value));
    const presetOptions = Object.values(PRESET).map((value) => option('presets', value));
    const metricOptions = ORDER_METRICS.map((value) => ({
        value,
        label: t(`tools.gsc.metrics.${value}`),
    }));

    const presetDisabled = draft.view !== VIEW.QUERIES;

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.pages_queries_changes.controls.view')}</label>
                <ReactSelect
                    options={viewOptions}
                    value={viewOptions.find((item) => item.value === draft.view)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ view: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.pages_queries_changes.controls.view_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.pages_queries_changes.controls.mode')}</label>
                <ReactSelect
                    options={modeOptions}
                    value={modeOptions.find((item) => item.value === draft.mode)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ mode: item.value })}
                />
                {draft.mode !== MODE.POPULAR && (
                    <span className="gsc-tool-field-note">
                        {t('tools.pages_queries_changes.controls.mode_note')}
                    </span>
                )}
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.pages_queries_changes.controls.metric')}</label>
                <ReactSelect
                    options={metricOptions}
                    value={metricOptions.find((item) => item.value === draft.metric)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ metric: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.pages_queries_changes.controls.metric_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.pages_queries_changes.controls.preset')}</label>
                <ReactSelect
                    options={presetOptions}
                    value={presetOptions.find((item) => item.value === draft.preset)}
                    blurInputOnSelect={true}
                    disabled={presetDisabled}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ preset: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {presetDisabled
                        ? t('tools.pages_queries_changes.controls.preset_pages_only')
                        : t('tools.pages_queries_changes.controls.preset_note', {
                              words: LONG_TAIL_MIN_WORDS,
                          })}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
